'use strict';

const dialog = require('./dialog'),
    toaster = require('./toaster'),
    page = require('./page'),
    grid = require('./grid'),
    appendParamsToUrl = require('./modules/util/appendParamsToUrl'),
    ajaxUrl = require('./modules/util/ajaxUrl'),
    minicart = require('./minicart'),
    checkout = require('./pages/checkout/singlepagecheckout'),
    isMobileWidth = require('./modules/util/isMobileWidth'),
    actionQueue = require('./actionQueue'),
    scrollHelper = require('./modules/helpers/scroll');

const maxItems = 1;
let giftAddClicked = false;
let onCart = false;
let onCheckout = false;
let onCloseCallback = null;
let newValue = null;
let previousValue = null;
let counter = 0;

function getMiniCart(options, addedProductId) {
    const url = ajaxUrl(Urls.minicart);

    $.ajax({
        type: 'GET',
        url: url,
        data: {
            pid: addedProductId
        }
    }).done(function (response) {
        if (!isMobileWidth()) {
            minicart.show(response, true);
        } else {
            bonusProductsView.show({ response: response}, false);
        }

        minicart.updateHeaderCartIcon($('.js-flyout-header .js-cart-quantity').val() || $(response).filter('.js-mobile-crm-toast').data('quantity'));
    }).fail(function (response) {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        }
    });
}

function getGWPBanner() {
    const gwpBannerEl = $('.js-gwp-banner');
    if (!gwpBannerEl.length) {
        return;
    }
    const height = gwpBannerEl.height();

    $.ajax({
        type: 'GET',
        url: Urls.getGwpCOPBanner
    }).done(function (response) {
        gwpBannerEl.empty().append($(response).find('.js-gwp-banner').html()).imagesLoaded(function(){
            if (gwpBannerEl.height() != height) {
                grid.reinitGridLayout(gwpBannerEl.parents('.js-grid-wrap').data('msnryId'));
            }
        });
    }).fail(function (response) {
            // handle error in the response
            if (response.error) {
                throw new Error(response.error);
            }
    });
}

const bonusProductsView = {
    /**
    * @function
    * @description Open the list of bonus products selection dialog
    */
    show: function (data, hideMinicart) {
        if (data.checkout) {
            onCheckout = true;
            data.url += '&onCheckout=true';
        } else if (!data.response || data.response === null) {
            onCart = true;
        }

        if (data.onClose) {
            onCloseCallback = data.onClose;
        }

        if (data.url && data.url !== null) {
           //Skip dialog - show minicart or small toast on mobile
            if (data.isAddedPopup){
                this.getGWPBanner();
                onBonusProductsViewBeforeClose(data);
                return;
            }

            const params = data.url.split('?').length > 1 ? '?' + data.url.split('?')[1] : '';
            let configuration = null;

            $.ajax({
                type: 'GET',
                url: Urls.getBonusProductsVueData + params
            }).done(function (response) {
                configuration = response;
                const flyinId = 'bonusProductChoice';
                const ProductChoiceList = require('./components/products/product-choice-list/product-choice-list.vue');
                const productsList = configuration.bonusProducts.map(bonusProduct => {
                    const analyticsData = {
                        productData: bonusProduct,
                        promotionName: bonusProduct.promotionName,
                        currencyCode: bonusProduct.currencyCode
                    };

                    return {
                        analyticsData: JSON.stringify(analyticsData),
                        id: 'item-' + bonusProduct.productUUID,
                        productName: bonusProduct.productName,
                        productType: bonusProduct.productType,
                        productID: bonusProduct.productID,
                        productUUID: bonusProduct.productUUID,
                        productHeading: bonusProduct.productHeading,
                        bonusDiscountLineItemUUID: bonusProduct.bonusDiscountLineItemUUID,
                        bonusProductID: bonusProduct.bonusProductID,
                        popupProductID: 'popup-product-' + bonusProduct.productID,
                        productImageUrl: bonusProduct.productImageUrl,
                        productImageTitle: bonusProduct.productImageTitle,
                        productImageAlt: bonusProduct.productImageAlt,
                        productImagePlaceholder: bonusProduct.productImagePlaceholder,
                        productImageClass: bonusProduct.productImageClass,
                        refillResource: bonusProduct.refillResource
                    };
                });
                const onChoiceMade = (productID) => {
                    const isCartPage = !!$('.js-cart-page-wrapper').length;
                    const selectedProduct = productsList.find(product => productID === product.productID);
                    const product = {
                        uuid: selectedProduct,
                        pid: selectedProduct.productID,
                        qty: 1,
                        name: selectedProduct.productName,
                        options: []
                    };

                    const url = appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: selectedProduct.bonusDiscountLineItemUUID});

                    const bonusproducts = [];
                    bonusproducts.push({product: product});

                    const bonusProducts = {bonusproducts: bonusproducts};
                    if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
                        bonusProducts.bonusproducts[0].product.qty = maxItems;
                    }

                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        cache: false,
                        contentType: 'application/json',
                        url: url,
                        data: JSON.stringify(bonusProducts)
                    }).done(function () {
                        if (isCartPage || onCart) {
                            page.refresh();
                        } else if (!onCheckout) {
                            let addedProductId = '';
                            if ('addedProductId' in data) {
                                addedProductId = data.addedProductId;
                            }
                            getMiniCart({}, addedProductId);
                        } else if (onCheckout){
                            checkout.updateSummary();
                        }
                    }).fail(function (_, textStatus) {
                        if (textStatus === 'parsererror') {
                            console.info(Resources.BAD_RESPONSE);
                        } else {
                            console.info(Resources.SERVER_CONNECTION_ERROR);
                        }
                    });

                    onBonusProductsViewBeforeClose(data);
                };
                scrollHelper.disableScroll();
                window.eventBus.$emit('shouldOpenFlyin', {
                    id: flyinId,
                    content: ProductChoiceList,
                    props: {
                        resources: configuration.resources,
                        products: productsList, onProductPicked: onChoiceMade,
                        selectedID: data.selectedID
                    },
                });
                window.eventBus.$on('flyinClosed', function() {
                    scrollHelper.enableScroll();

                    if (onCloseCallback) {
                        onCloseCallback();
                        // Clear pnCloseCallback so it doesn't open in case of multiple event emits
                        onCloseCallback = null;
                    }
                });

                onBonusProductsViewOpen();
            });

            if (configuration === null) {
                return;
            }

            return;
        } else {
            this.getGWPBanner();
        }

        if (!!data.response && data.response !== null) {
            if (!isMobileWidth()) {
                if (hideMinicart) {
                    minicart.update(data.response);
                } else {
                    minicart.show(data.response, true);
                }
            } else {
                // Check if we need to show the CRM mobile toast
                if (data.response.indexOf('js-mobile-crm-toast')) {
                    minicart.showMobileCrmToast(data.response);
                    if (counter === 0) {
                        //timeout in duration of crm showing animation
                        setTimeout(function() {
                            hideSameNumOfGifts();
                        }, 500);
                    }

                    //reseting counter to 0
                    $('.js-product-details-content .js-add-to-cart').on('click', function() {
                        counter = 0;
                    });

                    //reseting counter to 0 on COP
                    $('.js-product-tile-details-content .js-add-to-cart').each(function() {
                        $(this).on('click', function() {
                            counter = 0;
                        });
                    });
                    counter++;
                } else {
                    actionQueue.addToQueue(function() {
                        minicart.mobileConfirmation(data.response);
                    }, 4500);

                    if (data.displayGwpToast) {
                        showGwpToastMessage();
                    }
                }
            }

            minicart.updateHeaderCartIcon($('.js-flyout-header .js-cart-quantity').val() || $(data.response).filter('.js-mobile-crm-toast').data('quantity'));
        }
    },
    /**
    * @function
    * @description Open bonus product promo prompt dialog
    */
    loadBonusOption: function () {
        const self = this,
            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
        if (!bonusDiscountContainer) {
            return;
        }

        // get the html from minicart, then trash it
        const bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 720,
                title: Resources.BONUS_PRODUCT,
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    click: function () {
                        const uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = appendParamsToUrl(Urls.getBonusProducts, {
                                bonusDiscountLineItemUUID: uuid,
                                source: 'bonus',
                                format: 'ajax',
                                lazyLoad: 'false',
                                pageStart: 0,
                                pageSize: 10,
                                bonusProductsTotal: -1
                            });
                        $(this).dialog('close');
                        self.show(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function () {
                        $(this).dialog('close');
                    }
                }]
            },
            open: function(){
                $('.js-modal-overlay').show();
                $(document).on('click touchstart', '.js-modal-overlay', function(){
                    dialog.close();
                });
            },
            close: function(){
                $('.js-modal-overlay').hide();
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
            }
        });
    },
    getGWPBanner:getGWPBanner
};

function onBonusProductsViewOpen() {
    giftAddClicked = false;

    const tierStep = $('.js-gwp-tier-step').val();
    const dataLayer = [];
    if (tierStep > 0) {
        dataLayer.push({
            'event': 'GWPPopUpAdd',
            'threshold': tierStep
        });
    }
}

function onBonusProductsViewBeforeClose(data) {
    bonusProductsView.getGWPBanner();

    if (data.isAddedPopup) {
        if (!onCart) {
            getMiniCart({displayGwpToast: data.displayGwpToast});
        }
        return;
    }

    if (data.giftChange || giftAddClicked || onCart) {
        return;
    }

    getMiniCart({displayGwpToast: data.displayGwpToast});
}

function showGwpToastMessage() {
    actionQueue.addToQueue(function() {
        toaster.load({
            url: Urls.GetGwpToastBanner,
            close: function() {
                const isCartPage = $('.pt_cart').length > 0;
                if (isCartPage) {
                    location.reload();
                }
            }
        });
    }, 4500);
}

function hideSameNumOfGifts() {
    //checking if gwp contains any items
    if ($('.js-gwp-promotions').children().length !== 0) {
        newValue = $('.js-gwp-promotions').children().length;
        //if the num of items is the same
        if (previousValue === newValue) {
            $('.gwp-minicart-wrapper .approaching-header').addClass('hide');
            $('.gwp-minicart-wrapper .js-gwp-promotions').addClass('hide');
        //if the new item is added and number increased
        } else if (previousValue < newValue) {
            $('.gwp-minicart-wrapper .approaching-header').removeClass('hide');
            $('.gwp-minicart-wrapper .js-gwp-promotions').removeClass('hide');
            setTimeout(function() {
                //show only newly added gift
                $('.gwp-minicart-wrapper .js-gwp-promotions').each(function() {
                    $(this).children().addClass('hide');
                    $(this).children().last().removeClass('hide');
                });
            }, 250);
        }
        //setting the current num of items
        previousValue = newValue;
    }
}

module.exports = bonusProductsView;
